module.exports = __webpack_public_path__ + "img/opp2.7a0cce28.png";